import { AcademyProgressSchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * Academy progress for the signed-in agent (gap G18).
 *
 * `users/{uid}/academy/{trackId}` — the SAME shape and rules the operator
 * academy uses, so an agent who later runs their own carwash keeps one progress
 * document per track rather than two competing ideas of "what have I learned".
 *
 * Self-readable and self-writable under a pinned field set (firestore.rules).
 */
export function academyRepoFor(uid: string) {
  return createRepo({
    path: `users/${uid}/academy`,
    schema: AcademyProgressSchema,
    name: `users/${uid}/academy`,
  });
}
